export const ROUTES={
    HOME: "/",
    POPULAR: "/Popular",
    TOP_RATED: "/TopRated",
    NOW_PLAYING: "/NowPlaying",
    SHOW: '/show/',
    FAVORITES: '/Favorites',
}